import { Button, Input, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { no, triggerConfirmar } from "./confirmationSlice";

function ConfirmationModal() {

    var dispatch = useDispatch()
    var conf = useSelector((state) => state.confirmation)

    var close = () => {
        dispatch(no())
    }

    var confirmar = () => {
        dispatch(triggerConfirmar())
    }

    return <Modal open={conf.open} onClose={close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 400 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2"
                sx={{ textAlign: "center" }}>
                {conf.texto}
            </Typography>
            <Stack spacing={2} direction={"row"} sx={{
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Button color="danger" onClick={confirmar}> Sim </Button>
                <Button onClick={close}> Não </Button>
            </Stack>
        </ModalDialog>
    </Modal>
}

export default ConfirmationModal